import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IAttendant } from '../data/lista.interface';


@Injectable({
  providedIn: 'root'
})
export class AttendantService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Attendant`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  getActiveAttendantsByCompany(companyId: string): Observable<ResponseDefault<IAttendant[]>> {
    return this.http.get<ResponseDefault<IAttendant[]>>(`${this.apiUrl}/GetActiveAttendantsByCompany/${companyId}`);
  }

  getActiveAttendantsByPartner(partnerId: string): Observable<ResponseDefault<IAttendant[]>> {
    return this.http.get<ResponseDefault<IAttendant[]>>(`${this.apiUrl}/GetActiveAttendantsByPartner/${partnerId}`);
  }

  getActiveAttendants(): Observable<ResponseDefault<IAttendant[]>> {
    return this.http.get<ResponseDefault<IAttendant[]>>(`${this.apiUrl}/GetActiveAttendants`);
  }

  getAttendants(): Observable<ResponseDefault<IAttendant[]>> {
    return this.http.get<ResponseDefault<IAttendant[]>>(`${this.apiUrl}/GetAttendants`);
  }
}
